import React, { useEffect, useRef, useState } from "react";
import { compose } from "redux";
import enhancer from "./edit-outbox-validator";
import Button from "../button/Button";
import EncryptDecrypt from "api/EncryptDecrypt";
import EfaxManagementServices from "api/EfaxMangementServices";
import Toaster from "components/common/Toaster";

const EditOutboxModal = props => {
  const [loading, setLoading] = useState(false);
  const toaster = useRef();

  const {
    handleChange,
    handleBlur,
    submitCount,
    errors,
    values,
    touched,
    editedData,
    setFieldValue
  } = props;

  useEffect(() => {
    setFieldValue(true, true);
  }, []);

  const handleEdit = () => {
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      setLoading(true);
      let params = {
        fax_outbox_id: editedData.id,
        notes: values.notes
      };
      EfaxManagementServices.editOutboxFax(params)
        .then(result => {
          const res = EncryptDecrypt.decrypt(result.data);
          if (res.status) {
            if (toaster.current) toaster.current.success(res.message);
            setLoading(false);
            props.toggle();
            props.pageRefresh();
          } else {
            if (toaster.current) toaster.current.error(res.message);
            setLoading(false);
          }
        })
        .catch(err => {
          if (toaster.current) toaster.current.error(err.response);
          setLoading(false);
        });
    }

    handleSubmit();
  };
  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <div className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </div>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div>
      <form className="pa-24 row">
        <div className="form-group col-md-12">
          <label className="fs-16 medium-text">Note:</label>
          <textarea
            className="form-control react-form-input"
            rows="3"
            placeholder="Add Note"
            id="notes"
            name="notes"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.notes}
          ></textarea>
          <Error field="notes" />
        </div>
        <div className="col-12 text-center">
          <Button
            type="button"
            className="c-btn c-secondary form-button fs-16 demi-bold-text mr-10"
            style={{ maxWidth: "200px" }}
            onClick={props.toggle}
          >
            Cancel
          </Button>
          <Button
            type="button"
            loading={loading}
            disabled={loading}
            className="c-btn c-info form-button fs-16 demi-bold-text "
            style={{ maxWidth: "200px" }}
            onClick={() => {
              handleEdit();
            }}
            dataStyle="expand-right"
          >
            Save
          </Button>
        </div>
      </form>
      <Toaster ref={toaster} />
    </div>
  );
};
export default compose(enhancer)(EditOutboxModal);
